import * as React from "react";

function SvgIcSurvey(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4.5a2 2 0 012-2h8a1 1 0 01.707.293l6 6a1 1 0 01.293.707v10a2 2 0 01-2 2h-13a2 2 0 01-2-2v-15zm9 0h-7v15h13v-9h-4a2 2 0 01-2-2v-4zm2 1.414L17.086 8.5H14.5V5.914zm-6.854 8.44a.5.5 0 01.708-.708L9.5 14.793l1.146-1.147a.5.5 0 01.708.708L10.207 15.5l1.147 1.146a.5.5 0 01-.708.708L9.5 16.207l-1.146 1.147a.5.5 0 01-.708-.708L8.793 15.5l-1.147-1.146zm8.708.5a.5.5 0 00-.708-.708L14 15.793l-.646-.647a.5.5 0 00-.708.708l1 1a.5.5 0 00.708 0l2-2zM8 7h2v2H8V7zM7 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1V7z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcSurvey;
